export enum FavoritesIconEnum {
    FILLED = 'reaction-love-filled',
    OUTLINED = 'reaction-love-outlined'
}
